import request from '@/util/request'
import localCache from '../util/localCache';

export function getRecordList(params) {
    params.token = localCache.getToken()
    return request({
        url: '/getRecordList',
        method: 'get',
        params
    })
}

export function getYieldReportList(params) {
    params.token = localCache.getToken()
    return request({
        url: '/getYieldReportList',
        method: 'get',
        params
    })
}
export function getProductionReportdList(params) {
    params.token = localCache.getToken()
    return request({
        url: '/getProductionReportdList',
        method: 'get',
        params
    })
}

export function getMonthSalaryReportList(params) {
    params.token = localCache.getToken()
    return request({
        url: '/getMonthSalaryReportList',
        method: 'get',
        params
    })
}

export function getSalaryReportList(params) {
    params.token = localCache.getToken()
    return request({
        url: '/getSalaryReportList',
        method: 'get',
        params
    })
}

export function getStaffDayRecordList(params) {
    params.token = localCache.getToken()
    return request({
        url: '/getStaffDayRecordList',
        method: 'get',
        params
    })
}

export function getRecordListV1(params) {
    params.token = localCache.getToken()
    return request({
        url: '/getRecordListV1',
        method: 'get',
        params
    })
}
export function getRecordListV2(params) {
    params.token = localCache.getToken()
    return request({
        url: '/getRecordListV2',
        method: 'get',
        params
    })
}
export function getRecordListPrice(params) {
    params.token = localCache.getToken()
    return request({
        url: '/getRecordListPrice',
        method: 'get',
        params
    })
}
export function getRecordListProduct(params) {
    params.token = localCache.getToken()
    return request({
        url: '/getRecordListProduct',
        method: 'get',
        params
    })
}
export function getSupplierStatistics(params) {
    params.token = localCache.getToken()
    return request({
        url: '/getSupplierStatistics',
        method: 'get',
        params
    })
}
export function getSupplierRecord(params) {
    params.token = localCache.getToken()
    return request({
        url: '/getSupplierRecord',
        method: 'get',
        params
    })
}
